import { useEffect } from 'react';

import { CLARITY_ID } from 'commons/constants/env';
import { User } from 'commons/types/user';
import guid from 'commons/utils/guid';

import { Clarity as cl } from './utils';

import { getPageId } from './helper';

export const useClarity = (session: User, location: unknown) => {
  useEffect(() => {
    if (CLARITY_ID) {
      cl.init(CLARITY_ID);
      cl.set('sessionId', guid());
    }
  }, []);

  useEffect(() => {
    if (cl.hasStarted()) {
      cl.consent();
    }
  }, []);

  useEffect(() => {
    if (session?.user?.email && cl.hasStarted()) {
      cl.identify(session?.user.email, { name: session?.user.fullName });
      cl.setTag('user_email', session?.user.email);
    }
  }, [session?.user]);

  useEffect(() => {
    const titleProduct = getPageId({ url: window.location.pathname }) as string;

    if (cl.hasStarted()) {
      cl.setTag('page_id', titleProduct);
      cl.set('pageId', titleProduct);

      cl.upgrade('page has been changed by user navigation');
    }
  }, [location]);
};
